import {
  SubscriptionServiceStatus,
  SubscriptionServiceTypeCode,
} from '../data/common';
import instance from './API';
import { trim } from 'lodash';

const subscriptionAPI = {
  getServices: (
    typeCode = SubscriptionServiceTypeCode.ALL,
    status = SubscriptionServiceStatus.ALL,
  ) => {
    return instance.get(`/Subscription/price`, {
      params: {
        typeCode: typeCode,
        status: status,
      },
    });
  },
  subscriptionService: (serviceId, userId) => {
    return instance.get(`/Member/ActiveSubscription`, {
      params: {
        SubscriptionServiceId: trim(serviceId),
        UserId: trim(userId),
      },
    });
  },
  getUserServices: (userId) => {
    return instance.get(`/SubscriptionServiceInfo/User/${userId}`);
  },
  claimDailyItems: (claimList) => {
    return instance.post(`/SubscriptionServices/ClaimDailyItem`, {
      ClaimList: claimList,
    });
  },
  getAllUserSubscriptionServices: (page, count, keyword, startAt, endAt) => {
    const params = {
      page: page,
      count: count,
      startAt: trim(startAt) !== '' ? startAt : '',
      endAt: trim(endAt) !== '' ? endAt : '',
    };

    if (trim(keyword) !== '') {
      params.keyword = keyword;
    }

    return instance.get('/SubscriptionTransaction', {
      params: params,
    });
  },
};

export default subscriptionAPI;
